import "../index.css";
import Footer from "../components/Footer";
import { useAuth } from "../auth/context";
import { PageNav } from "../components/PageNav";
import { useNavigate } from "react-router-dom";
import ImageUpload from "../components/ImageUpload";
// import NotificationSettings from "../components/NotificationSettings";
import { useState, useEffect } from "react";
import { USERNAME, WEB_URL } from "../auth/types";
import ApiCall from "../auth/ApiCall";
import buttonBackground from "../assets/button_background_blue.webp";
//import buttonBackgroundRed from "../assets/button_background_red.webp";
import { plans } from "../types/planTypes";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../auth/firebase";
import { useDevices, revokeDevice } from "../apiCalls/Devices";
// import { themes, applyTheme, getCurrentTheme } from "../utils/themes";
// import { fonts, applyFont, getCurrentFont } from "../utils/fonts";
//import { GetUserAvatar } from "../backend_calls/GetUserAvatar";

export default function UserSettings() {
  //  const { user, loading, logout } = useAuth();
  const { logout } = useAuth();
  const navigate = useNavigate();

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOpenPortal = async () => {
    const response = (await ApiCall.makeAuthenticatedRequest(
      "/accounts/api/payments/stripe/portal/",
      {
        method: "POST",
        body: JSON.stringify({ return_url: WEB_URL + "/settings" }),
      },
    )) as { url?: string; session_id?: string; error?: string };

    if (response.url) {
      window.location.href = response.url;
    }
  };

  // Redirect new users (state 1) to subscribe page
  useEffect(() => {
    const stateId = localStorage.getItem("state_id");
    if (stateId === "1") {
      navigate("/subscribe");
    }
  }, [navigate]);
  // const { avatar, isAvatarLoading, avatarError, avatarRefetch } =
  //   GetUserAvatar();
  // const [currentUrl, setCurrentUrl] = useState(null);
  const [preview, setPreview] = useState(localStorage.getItem("avatar_url"));
  const [editingUsername, setEditingUsername] = useState<boolean>(false);
  const [passwordError, setPasswordError] = useState<string>("");
  const [passwordSuccess, setPasswordSuccess] = useState<boolean>(false);
  const [username, setUsername] = useState<string>(
    localStorage.getItem(USERNAME) || "",
  );
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  const [usernameSaved, setUsernameSaved] = useState(
    localStorage.getItem(USERNAME) || "",
  );
  // const [isMobile, setIsMobile] = useState(false);
  // const [selectedTheme, setSelectedTheme] = useState<string>(getCurrentTheme());
  // const [selectedFont, setSelectedFont] = useState<string>(getCurrentFont());

  // Detect mobile device
  //   useEffect(() => {
  // //     const checkMobile = () => {
  // //       const userAgent = navigator.userAgent || navigator.vendor;
  // //       // const isMobileDevice =
  // //       //   /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
  // //       //     userAgent.toLowerCase(),
  // //       //   ) || window.innerWidth < 768;
  // // //      setIsMobile(isMobileDevice);
  // //     };

  //     checkMobile();
  //     window.addEventListener("resize", checkMobile);
  //     return () => window.removeEventListener("resize", checkMobile);
  //   }, []);

  // useEffect(() => {
  //   if (avatar) {
  //     setPreview(avatar);
  //   }
  // }, [avatar]);

  const handleLogout = async (): Promise<void> => {
    try {
      await logout();
      navigate("/");
    } catch {
      //      console.error("Logout failed:", error);
    }
  };

  const handleUrlUpdate = (url?: string | null) => {
    //    setAvatar(url);
    if (url) {
      setPreview(url);
      localStorage.setItem("avatar_url", url);
    }
  };

  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(event.target.value);
  };

  const updateUsernameClick = async () => {
    setUsernameSaved(username);
    setEditingUsername(!editingUsername);
    // setLoading(true);
    // setError(null);
    localStorage.setItem(USERNAME, username);

    // Trigger a storage event to update PageNav
    window.dispatchEvent(new Event("storage"));

    try {
      const jsonData = {
        first_name: username,
      };

      ApiCall.makeAuthenticatedRequest(
        "/accounts/api/user/profile/update_name/",
        {
          method: "PUT",
          // headers: {
          //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${token}`, // Add token with Bearer prefix
          // },
          body: JSON.stringify(jsonData),
        },
      );

      // const response = await fetch(BASE_URL + "/api/update_username/", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${token}`, // Add token with Bearer prefix
      //   },
      //   body: JSON.stringify({
      //     username: username,
      //   }),
      // });

      // if (!response.ok) {
      //   throw new Error(`HTTP error! Status: ${response.status}`);
      // }
      // } catch (err) {
    } catch {
      // setError(err instanceof Error ? err.message : "An unknown error occurred");
    } finally {
      // setLoading(false);
    }
  };

  // const updateSubscriptionClick = () => {

  // }

  const cancelUsernameClick = () => {
    setUsername(usernameSaved);
    setEditingUsername(!editingUsername);
  };

  const handlePasswordReset = async () => {
    setPasswordError("");
    setPasswordSuccess(false);
    const user = auth.currentUser;
    if (!user || !user.email) {
      setPasswordError("Unable to find your account. Please log in again.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, user.email);
      setPasswordSuccess(true);
    } catch {
      setPasswordError("Failed to send reset email. Please try again.");
    }
  };

  const editUsernameClick = () => {
    setEditingUsername(!editingUsername);
  };

  // const handleThemeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
  //   const newTheme = event.target.value;
  //   setSelectedTheme(newTheme);
  //   applyTheme(newTheme);
  // };

  // const handleFontChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
  //   const newFont = event.target.value;
  //   setSelectedFont(newFont);
  //   applyFont(newFont);
  // };

  const formatSubscriptionDate = (dateString: string | null): string => {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return dateString;
    }
  };

  // Get membership status message based on state_id
  const getMembershipMessage = (): {
    title: string;
    message: string;
  } | null => {
    const stateId = localStorage.getItem("state_id");

    switch (stateId) {
      case "4": // Expired Subscription
        return {
          title: "Subscription Expired",
          message:
            "Your subscription has expired. Please update your payment method or renew your subscription to continue using our service.",
        };
      case "5": {
        // Cancelled trial or expired trial
        const expiration = localStorage.getItem("subscription_expiration");
        const isStillActive = expiration && new Date(expiration) > new Date();
        if (isStillActive) {
          return {
            title: "Trial Cancelled",
            message: `Your trial has been cancelled but you still have access until ${formatSubscriptionDate(expiration)}. Subscribe before then to keep your access.`,
          };
        }
        return {
          title: "Trial Ended",
          message:
            "Your free trial has ended. Subscribe now to continue enjoying full access to all features.",
        };
      }
      case "6": // Cancelled
        return {
          title: "Subscription Cancelled",
          message:
            "Your subscription has been cancelled. Resubscribe to regain access to all features.",
        };
      default:
        return null;
    }
  };

  const membershipMessage = getMembershipMessage();

  const {
    devices,
    maxDevices,
    isLoading: devicesLoading,
    error: devicesError,
    refetch: refetchDevices,
  } = useDevices();
  const [revokingDeviceId, setRevokingDeviceId] = useState<number | null>(
    null,
  );

  const formatLastSeen = (dateString: string): string => {
    const date = new Date(dateString);
    const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
    if (diffSec < 60) return "Just now";
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin} minute${diffMin === 1 ? "" : "s"} ago`;
    const diffHour = Math.floor(diffMin / 60);
    if (diffHour < 24) return `${diffHour} hour${diffHour === 1 ? "" : "s"} ago`;
    const diffDay = Math.floor(diffHour / 24);
    if (diffDay < 30) return `${diffDay} day${diffDay === 1 ? "" : "s"} ago`;
    return formatSubscriptionDate(dateString);
  };

  const handleRevokeDevice = async (deviceId: number, deviceName: string) => {
    if (
      !window.confirm(
        `Sign out "${deviceName}"? It will need to log in again.`,
      )
    )
      return;
    setRevokingDeviceId(deviceId);
    await revokeDevice(deviceId);
    setRevokingDeviceId(null);
    refetchDevices();
  };

  return (
    <div>
      <PageNav avatar_path={preview || ""} />
      {/* <div className="main_div"> */}
      {/* {isAvatarLoading ? (
        <div />
      ) : ( */}
      <div className="main_div">
        {membershipMessage && (
          <div
            className="center_me"
            style={{
              marginBottom: 20,
              padding: "15px 20px",
              backgroundColor: "#ff0000",
              borderRadius: 20,
              maxWidth: 500,
              marginLeft: "auto",
              marginRight: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3
              className="font_family_base"
              style={{
                color: "white",
                marginBottom: 8,
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              {membershipMessage.title}
            </h3>
            <p
              className="font_family_base"
              style={{
                color: "white",
                marginBottom: 12,
                fontSize: 14,
                lineHeight: 1.4,
              }}
            >
              {membershipMessage.message}
            </p>
            <button
              onClick={() => {
                const stateId = localStorage.getItem("state_id");
                const exp = localStorage.getItem("subscription_expiration");
                const isExpired = !exp || new Date(exp) <= new Date();
                if (stateId === "4" || (stateId === "5" && isExpired)) {
                  handleOpenPortal();
                } else if (stateId === "1") {
                  navigate("/subscribe");
                } else {
                  navigate("/subscription/update");
                }
              }}
              className="my-form-button button-base button-3d font_family_base"
              style={{
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                width: 200,
                fontWeight: 700,
                padding: "10px 20px",
                fontSize: 14,
              }}
            >
              {(() => {
                const stateId = localStorage.getItem("state_id");
                const exp = localStorage.getItem("subscription_expiration");
                const isExpired = !exp || new Date(exp) <= new Date();
                return stateId === "4" || (stateId === "5" && isExpired)
                  ? "Update Payment"
                  : "Update Subscription";
              })()}
            </button>
          </div>
        )}
        <div className="center_me">
          <button
            onClick={handleLogout}
            className="my-form-button button-base button-3d font_family_base"
            style={{
              marginTop: "5px",
              marginBottom: "5px",
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
            }}
          >
            Logout
          </button>
        </div>
        <div style={{ marginTop: 20 }}>
          <ImageUpload
            avatar={preview || ""}
            preview={preview}
            setPreview={handleUrlUpdate}
            currentImageUrl={preview}
            setCurrentImageUrl={handleUrlUpdate}
          />
        </div>
        {/* <div className="active_form_state">
          <h2 className="title_line">USER SETTINGS</h2>
        </div> */}
        <div className="center_me" style={{ marginTop: 20 }}>
          <div
            className="left_spacer right_spacer"
            style={{ width: 500, maxWidth: "100%" }}
          >
            {/* <div className="row" style={{ alignItems: "center" }}> */}
            <p className="font_family_base">EMAIL:</p>
            <p
              className="border_gray min-width-350 font_family_base"
              style={{
                height: 40,
                maxWidth: 500,
                width: "100%",
                paddingLeft: "10px",
                display: "flex",
                alignItems: "center",
                background: "#000",
                // border: "1px solid #ccc",
                // padding: "8px",
                // borderRadius: "4px",
              }}
              // style={{ textAlign: "right" }}
            >
              {localStorage.getItem("email")}
            </p>
            {/* </div> */}
            {/* <div
              className="row"
              style={{ alignItems: "center", marginTop: 20 }}
            > */}
            <p className="top_buffer font_family_base detail_text">USERNAME:</p>
            <div
              className="row border_gray"
              style={{
                height: 40,
                maxWidth: 500,
                width: "100%",
                paddingLeft: "10px",
                display: "flex",
                alignItems: "center",
                background: "#000",
              }}
            >
              {editingUsername ? (
                <>
                  <div className="col2">
                    <input
                      className="text_black font_family_base"
                      key="rule_name"
                      type="text"
                      id="rule_name"
                      name="rule_name"
                      placeholder="User Name..."
                      value={username}
                      onChange={handleUsernameChange}
                      style={{ paddingLeft: "10px" }}
                    ></input>
                  </div>
                  <div className="col2 right_align">
                    <button
                      onClick={updateUsernameClick}
                      className="blue_text"
                      style={{
                        background: "transparent",
                        border: "none",
                        fontSize: "24px",
                        cursor: "pointer",
                      }}
                    >
                      ✅
                    </button>
                    <button
                      onClick={cancelUsernameClick}
                      className="blue_text"
                      style={{
                        background: "transparent",
                        border: "none",
                        fontSize: "24px",
                        cursor: "pointer",
                      }}
                    >
                      ❌
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="col2of3">
                    <p className="font_family_base">{username}</p>
                  </div>
                  <div className="col1of3 right_align font_family_base">
                    <button
                      onClick={editUsernameClick}
                      className="my-form-button button-base button-3d font_family_base"
                      style={{
                        backgroundImage: `url(${buttonBackground})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        color: "white",
                        fontWeight: 700,
                        height: 22,
                        minHeight: 22,
                        padding: "2px 12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        marginRight: 5,
                        width: 80,
                      }}
                      //         className="update-button font_family_base button_text button_color"
                      // style={{
                      //   height: 30,
                      //   display: "flex",
                      //   alignItems: "center",
                      //   justifyContent: "center",
                      // }}
                    >
                      UPDATE
                    </button>
                  </div>
                </>
              )}
            </div>
            {/* </div> */}
            {/* <p className="top_buffer font_family_base">ODDS FORMAT:</p>
              <div className="row border_gray max-width-500">
                <div className="col2">
                  <select
                    className="text_black font_family_base"
                    value={oddType}
                    onChange={handleOddTypeChange}
                  >
                    {oddsTypes.map((item) => (
                      <option
                        className="font_family_base"
                        value={item}
                        id={item}
                        key={item}
                      >
                        {item}Do we update the
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
            {localStorage.getItem("provider") === "email" && (
              <>
                <p className="top_buffer font_family_base detail_text">
                  PASSWORD:
                </p>
                <div
                  className="row border_gray"
                  style={{
                    height: 40,
                    maxWidth: 500,
                    width: "100%",
                    paddingLeft: 10,
                    display: "flex",
                    alignItems: "center",
                    background: "#000",
                  }}
                >
                  <div className="col2of3">
                    {passwordSuccess ? (
                      <p
                        className="font_family_base"
                        style={{ color: "#4ade80", fontSize: 13 }}
                      >
                        Reset email sent!
                      </p>
                    ) : passwordError ? (
                      <p
                        className="font_family_base"
                        style={{ color: "#ef4444", fontSize: 13 }}
                      >
                        {passwordError}
                      </p>
                    ) : (
                      <p className="font_family_base">••••••••</p>
                    )}
                  </div>
                  <div
                    className="col1of3 right_align"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      onClick={handlePasswordReset}
                      className="my-form-button button-base button-3d font_family_base"
                      style={{
                        backgroundImage: `url(${buttonBackground})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        color: "white",
                        fontWeight: 700,
                        height: 22,
                        minHeight: 22,
                        padding: "2px 12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        marginRight: 5,
                        width: 80,
                      }}
                    >
                      RESET
                    </button>
                  </div>
                </div>
              </>
            )}

            {localStorage.getItem("state_id") !== "7" &&
              localStorage.getItem("state_id") !== "8" && (
                <>
                  <p className="top_buffer font_family_base detail_text">
                    SUBSCRIPTION PLAN:
                  </p>
                  <div
                    className="row border_gray"
                    style={{
                      height: 40,
                      maxWidth: 500,
                      width: "100%",
                      paddingLeft: "10px",
                      display: "flex",
                      alignItems: "center",
                      background: "#000",
                      // border: "1px solid #ccc",
                      // padding: "5px",
                      // borderRadius: "4px",
                    }}
                  >
                    <div className="col2of3">
                      <p className="font_family_base" style={{ padding: 5 }}>
                        {(() => {
                          const stateId = localStorage.getItem("state_id");
                          const subId =
                            localStorage.getItem("subscription_id") || "";
                          const subName =
                            localStorage.getItem("subscription_name");
                          if (
                            stateId === "5" ||
                            stateId === "2" ||
                            stateId === "4"
                          ) {
                            const match = plans.find(
                              (p) =>
                                p.idMonthly === subId || p.idAnnual === subId,
                            );
                            if (match) {
                              const isMonthly = subId === match.idMonthly;
                              const name = isMonthly
                                ? match.nameMonthly
                                : match.nameAnnual;
                              return `${name} Plan (${isMonthly ? "Monthly" : "Annual"})`;
                            }
                          }
                          return subName;
                        })()}
                        {["2", "4", "5"].includes(
                          localStorage.getItem("state_id") || "",
                        ) && (
                          <span
                            style={{
                              color: "#ff6b6b",
                              fontSize: 12,
                              marginLeft: 8,
                            }}
                          >
                            {(() => {
                              const sid = localStorage.getItem("state_id");
                              const exp = localStorage.getItem(
                                "subscription_expiration",
                              );
                              const isExpired =
                                !exp || new Date(exp) <= new Date();
                              if (sid === "4" || sid === "5") return null;
                              if (sid === "2" && !isExpired) return null;
                              // if (sid === "5" && !isExpired)
                              //   return "(Cancelled)";
                              return "(Expired)";
                            })()}
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="col1of3 right_align font_family_base">
                      <button
                        onClick={() => {
                          const stateId = localStorage.getItem("state_id");
                          const noActiveSub = stateId === "1";
                          navigate(
                            noActiveSub ? "/subscribe" : "/subscription/update",
                          );
                        }}
                        className="my-form-button button-base button-3d font_family_base"
                        style={{
                          backgroundImage: `url(${buttonBackground})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          color: "white",
                          fontWeight: 700,
                          height: 22,
                          minHeight: 22,
                          padding: "2px 12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 12,
                          marginRight: 5,
                          width: 80,
                        }}
                      >
                        UPDATE
                      </button>
                    </div>
                  </div>
                </>
              )}
            {localStorage.getItem("pending_subscription_id") &&
              localStorage.getItem("pending_subscription_id") !== "" && (
                <>
                  <p
                    className="top_buffer font_family_base detail_text"
                    // style={{ color: "#ff9800", fontWeight: "bold" }}
                    // style={{ color: "#ff9800" }}
                  >
                    PENDING PLAN (Effective Next Billing Cycle):
                  </p>
                  <p
                    className="border_gray max-width-500 font_family_base"
                    style={{
                      height: 40,
                      maxWidth: 500,
                      width: "100%",
                      paddingLeft: "10px",
                      display: "flex",
                      alignItems: "center",
                      background: "#000",
                    }}
                  >
                    {localStorage.getItem("pending_subscription_name")}
                  </p>
                </>
              )}
            {["2", "3", "4", "5", "6"].includes(
              localStorage.getItem("state_id") || "",
            ) &&
              (() => {
                const stateId = localStorage.getItem("state_id");
                const exp = localStorage.getItem("subscription_expiration");
                const isActive = exp && new Date(exp) > new Date();
                // For states 4, 5, 6, only show if not yet expired
                if (
                  (stateId === "4" || stateId === "5" || stateId === "6") &&
                  !isActive
                )
                  return null;
                const label =
                  stateId === "2"
                    ? "TRIAL EXPIRATION:"
                    : stateId === "5"
                      ? "ACCESS UNTIL:"
                      : stateId === "6"
                        ? "ACCESS UNTIL:"
                        : "SUBSCRIPTION EXPIRATION:";
                return (
                  <>
                    <p className="top_buffer font_family_base detail_text">
                      {label}
                    </p>
                    <p
                      className="border_gray max-width-500 font_family_base"
                      style={{
                        height: 40,
                        maxWidth: 500,
                        width: "100%",
                        paddingLeft: "10px",
                        display: "flex",
                        alignItems: "center",
                        background: "#000",
                      }}
                    >
                      {formatSubscriptionDate(exp)}
                    </p>
                  </>
                );
              })()}
            <p className="top_buffer font_family_base detail_text">
              SIGNED-IN DEVICES
              {!devicesLoading && !devicesError && (
                <span style={{ color: "#9ca3af", fontWeight: "normal" }}>
                  {" "}
                  ({devices.length} of {maxDevices})
                </span>
              )}
              :
            </p>
            {devicesLoading ? (
              <p className="font_family_base" style={{ color: "#9ca3af" }}>
                Loading...
              </p>
            ) : devicesError ? (
              <p
                className="font_family_base"
                style={{ color: "#ef4444", fontSize: 13 }}
              >
                {devicesError}
              </p>
            ) : (
              devices.map((device) => (
                <div
                  key={device.id}
                  className="row border_gray"
                  style={{
                    minHeight: 40,
                    maxWidth: 500,
                    width: "100%",
                    paddingLeft: 10,
                    paddingRight: 10,
                    paddingTop: 8,
                    paddingBottom: 8,
                    marginBottom: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: "#000",
                  }}
                >
                  <div>
                    <p className="font_family_base" style={{ marginBottom: 2 }}>
                      {device.device_name || device.platform}
                      {device.is_current && (
                        <span
                          className="text_green"
                          style={{ fontSize: 12, marginLeft: 8 }}
                        >
                          This Device
                        </span>
                      )}
                    </p>
                    <p
                      className="font_family_base"
                      style={{ color: "#9ca3af", fontSize: 12 }}
                    >
                      Last active {formatLastSeen(device.last_seen_at)}
                    </p>
                  </div>
                  {!device.is_current && (
                    <button
                      onClick={() =>
                        handleRevokeDevice(
                          device.id,
                          device.device_name || device.platform,
                        )
                      }
                      disabled={revokingDeviceId === device.id}
                      className="my-form-button button-base button-3d font_family_base"
                      style={{
                        backgroundImage: `url(${buttonBackground})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        color: "white",
                        fontWeight: 700,
                        height: 22,
                        minHeight: 22,
                        padding: "2px 12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        flexShrink: 0,
                      }}
                    >
                      {revokingDeviceId === device.id
                        ? "SIGNING OUT..."
                        : "SIGN OUT"}
                    </button>
                  )}
                </div>
              ))
            )}
            {/* {!isMobile && (
              <>
                <p className="top_buffer font_family_base">
                  DESKTOP NOTIFICATIONS:
                </p>
                <NotificationSettings />
              </>
            )} */}
            {/* <p className="top_buffer font_family_base">COLOR SCHEME:</p>
            <div
              className="row border_gray"
              style={{
                height: 40,
                maxWidth: 500,
                width: "100%",
                border: "1px solid #ccc",
                padding: "5px",
                borderRadius: "4px",
                background: "#000",
              }}
            >
              <div className="col1">
                <select
                  className="text_black font_family_base"
                  value={selectedTheme}
                  onChange={handleThemeChange}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    backgroundColor: "transparent",
                    color: "white",
                    padding: "0 5px",
                  }}
                >
                  {Object.entries(themes).map(([key, theme]) => (
                    <option
                      className="font_family_base"
                      value={key}
                      key={key}
                      style={{ backgroundColor: "#2e2e2e", color: "white" }}
                    >
                      {theme.name}
                    </option>
                  ))}
                </select>
              </div>
            </div> */}
            {/* <p className="top_buffer font_family_base">FONT FAMILY:</p>
            <div
              className="row border_gray"
              style={{
                height: 40,
                maxWidth: 500,
                width: "100%",
                border: "1px solid #ccc",
                padding: "5px",
                borderRadius: "4px",
              }}
            >
              <div className="col1">
                <select
                  className="text_black font_family_base"
                  value={selectedFont}
                  onChange={handleFontChange}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    backgroundColor: "transparent",
                    color: "white",
                    padding: "0 5px",
                  }}
                >
                  {Object.entries(fonts).map(([key, font]) => (
                    <option
                      className="font_family_base"
                      value={key}
                      key={key}
                      style={{ backgroundColor: "#2e2e2e", color: "white" }}
                    >
                      {font.name}
                    </option>
                  ))}
                </select>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* <div className="center_me" style={{ marginTop: 30, marginBottom: 20 }}>
        <button
          onClick={() => navigate("/delete-account")}
          className="my-form-button button-base button-3d-red font_family_base"
          style={{
            marginTop: "5px",
            marginBottom: "5px",
            backgroundImage: `url(${buttonBackgroundRed})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "white",
            fontWeight: 700,
            width: 200,
          }}
        >
          Delete Account
        </button>
      </div> */}
      <Footer />
    </div>
  );
}
